export const transformText = (text) => {
  const textWithoutSources = text
    .replaceAll("【5†source】", "")
    .replaceAll("#", "-");
  const lines = textWithoutSources.split("\n");
  return lines.map((paragraph, index) => {
    const isHeading = paragraph.startsWith("---");
    const content = isHeading ? paragraph.substring(3) : paragraph;
    return (
      <p key={index} style={{ marginTop: 0 }}>
        {content.split("**").map((part, i) => {
          if (i % 2 === 0 && !isHeading) {
            return part;
          } else {
            return <strong key={i}>{part}</strong>;
          }
        })}
      </p>
    );
  });
};
